/**
 * Dates de dernier audit factuel par page éditoriale.
 * Clé identique à celle des références (`<type>/<slug>`).
 */
export type AuditRecord = {
  /** Date du dernier contrôle (format lisible). */
  date: string;
  /** Nature du contrôle mené. */
  method: string;
};

const audits: Record<string, AuditRecord> = {
  "theme/rallye-et-sport-auto": {
    date: "24 août 2026",
    method: "Recoupement Wikipédia/FIA, Motorsport.com, Autosport et Auto Hebdo",
  },
  "theme/trail-et-outdoor": {
    date: "24 août 2026",
    method: "Recoupement Le Parisien, Sport.fr, Mon GR20 et UTMB World Series",
  },
  "theme/velo-et-gt20": {
    date: "24 août 2026",
    method: "Recoupement Visit Corsica, ASO/Tour de France, BikingMan et Wikipédia (cols)",
  },
  "theme/mer-et-plongee": {
    date: "24 août 2026",
    method: "Recoupement UNESCO, Parc naturel régional de Corse, DRASSM et Office de l'environnement de la Corse",
  },
  "theme/sport-et-football": {

    date: "24 août 2026",
    method: "Recoupement FFF, UEFA, L'Équipe, France 3 Corse et Corse-Matin",
  },
  "dossier/sporting-club-bastia": {
    date: "24 août 2026",
    method: "Palmarès UEFA/FFF, presse nationale et régionale",
  },
  "dossier/ac-ajaccio": {
    date: "24 août 2026",
    method: "Classements L'Équipe, décisions DNCG, archives club",
  },
  "dossier/gazelec-ajaccio": {
    date: "24 août 2026",
    method: "Historique officiel du club et décisions DNCG",
  },
  "dossier/furiani-1992": {
    date: "24 août 2026",
    method: "Texte de loi Légifrance et bilans officiels",
  },
  "dossier/frederic-antonetti": {
    date: "24 août 2026",
    method: "Fiches L'Équipe/FFF et communiqués de clubs",
  },
  "dossier/pascal-olmeta": {
    date: "24 août 2026",
    method: "Feuilles de match et biographies de référence",
  },
  "dossier/legendes-du-football-corse": {
    date: "24 août 2026",
    method: "Archives INA et fiches joueurs",
  },
  "dossier/entraineurs-du-football-corse": {
    date: "24 août 2026",
    method: "Communiqués officiels de nomination",
  },
  "dossier/echecs-en-corse": {
    date: "24 août 2026",
    method: "Ligue corse des échecs, FIDE, ChessBase",
  },
  "dossier/marc-andria-maurizzi": {
    date: "24 août 2026",
    method: "Classements FIDE et Fédération française des échecs",
  },
  "dossier/dume-guidi": {
    date: "24 août 2026",
    method: "Fiches Ligue 2/FFF, Corse-Matin, communiqués du SC Bastia",
  },
  "dossier/christophe-vincent": {
    date: "24 août 2026",
    method: "Fiches Ligue 2/FFF, Corse-Matin, communiqués de clubs",
  },
};

/** Renvoie l'audit factuel connu pour une clé de page. */
export function auditFor(key: string | undefined): AuditRecord | null {
  if (!key) return null;
  return audits[key] ?? null;
}
